import { render, staticRenderFns } from "./LocalComment.vue?vue&type=template&id=0563eb34&scoped=true"
import script from "./LocalComment.vue?vue&type=script&lang=js"
export * from "./LocalComment.vue?vue&type=script&lang=js"
import style0 from "./LocalComment.vue?vue&type=style&index=0&id=0563eb34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0563eb34",
  null
  
)

export default component.exports